import { Breakpoints } from '../styled/constants';
import { useMatchMedia } from './useMatchMedia';

const useScreenSize = () => {
  const minTablet = useMatchMedia(`(min-width: ${Breakpoints.tablet}px)`);
  const minSmallDesktop = useMatchMedia(
    `(min-width: ${Breakpoints.smallDesktop}px)`
  );
  const minDesktop = useMatchMedia(`(min-width: ${Breakpoints.desktop}px)`);
  const minPashaSmallDesktop = useMatchMedia(
    `(min-width: ${Breakpoints.PashaSmallDesktop}px)`
  );
  const minPashaCustomDesktop = useMatchMedia(
    `(min-width: ${Breakpoints.PashaCustomDesktop}px)`
  );

  const PashaLinkSmallDesktop = minPashaSmallDesktop;
  const PashaLinkLargeDesktop = minPashaCustomDesktop;
  const PashaLinkCustomDesktop = minPashaSmallDesktop && !minPashaCustomDesktop;
  const isLarge = minDesktop;
  const isMedium = minTablet && !minDesktop;
  const isSmallDesktop = minSmallDesktop && !minDesktop;
  const isTablet = minTablet && !minSmallDesktop;
  const isSmall = !minTablet;
  const isSmallOrLargeDesktop = isSmallDesktop || isLarge;

  return {
    PashaLinkSmallDesktop,
    PashaLinkLargeDesktop,
    PashaLinkCustomDesktop,
    isLarge,
    isMedium,
    isSmall,
    isTablet,
    isSmallDesktop,
    isSmallOrLargeDesktop
  };
};

export default useScreenSize;
